import { useMemo } from 'react';
import type { ChannelMember } from '../lib/api';
import { usePresenceStore } from '../stores/usePresenceStore';
import { useAuthStore } from '../stores/useAuthStore';
import { useChannelStore } from '../stores/useChannelStore';
import { useChannelMemberStore } from '../stores/useChannelMemberStore';
import { useDmStore } from '../stores/useDmStore';
import { useThreadStore } from '../stores/useThreadStore';
import { resolveNormalizedSessionScope } from '../lib/normalized-session-scope';

/** Re-resolve when authoritative ownership metadata arrives or changes. */
export function useNormalizedSessionScope(channelId: string, agentId: string | undefined) {
  const accountId = useAuthStore(state => state.currentUser?.id);
  const channels = useChannelStore(state => state.channels);
  const dms = useDmStore(state => state.dmChannels);
  const threadChannels = useChannelMemberStore(state => state.threadChannelsById);
  const threads = useThreadStore(state => state.byMessage);
  return useMemo(() => agentId ? resolveNormalizedSessionScope(channelId, agentId) : undefined,
    [accountId, channelId, agentId, channels, dms, threadChannels, threads]);
}

/** Live declarations override HTTP roster snapshots, including explicit unknown values. */
export function useProviderOutputMode(agent?: Pick<ChannelMember, 'user_id' | 'provider_output_mode'>) {
  const declaration = usePresenceStore(state => agent ? state.providerOutputModes[agent.user_id] : undefined);
  const epoch = usePresenceStore(state => state.providerOutputEpoch);
  return declaration === undefined && epoch === 0 ? agent?.provider_output_mode : declaration ?? undefined;
}
